import { useQuery } from 'react-query';
import { EQueryConst } from 'features/service/config';
import { getBackendVersion } from 'features/service/dev-controller/api';
import { extractVersion } from 'components/layout/Header/Version/common/utils/utils';

const GetVersion = () =>
    useQuery(
    [EQueryConst.GET_BACKEND_VERSION],
    () =>
      getBackendVersion(), {
      keepPreviousData: true,
      refetchOnMount: false,
      select: data => extractVersion(data),
    });

export { GetVersion };
